var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 16C17.4726 16 18.6665 14.8061 18.6665 13.3333C18.6665 11.8606 17.4726 10.6667 15.9998 10.6667C14.5271 10.6667 13.3332 11.8606 13.3332 13.3333C13.3332 14.8061 14.5271 16 15.9998 16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 4C10.8452 4 6.6665 8.19674 6.6665 13.3737C6.6665 17.0244 11.308 23.5174 14.0447 27.0284C15.0502 28.3185 16.9495 28.3185 17.955 27.0284C20.6917 23.5174 25.3332 17.0244 25.3332 13.3737C25.3332 8.19674 21.1545 4 15.9998 4ZM15.9998 6.66667C12.3288 6.66667 9.33317 9.65864 9.33317 13.3737C9.33317 13.7845 9.47982 14.5027 9.90527 15.5504C10.3147 16.5587 10.9086 17.6957 11.6195 18.8872C12.649 20.613 13.861 22.3494 14.9597 23.8283C15.4794 24.5278 16.5203 24.5278 17.04 23.8283C18.1387 22.3494 19.3507 20.613 20.3802 18.8872C21.0911 17.6957 21.685 16.5587 22.0944 15.5504C22.5199 14.5027 22.6665 13.7845 22.6665 13.3737C22.6665 9.65864 19.6709 6.66667 15.9998 6.66667Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.bbf0c6737d7ec380edbc736499d6be4d.svg";
export { ForwardRef as ReactComponent };